<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--zero-balance modal--purchase" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_welcome_back_returning_back_welcome_back }} {{ userDetails.username }}!</h1>
          <img class="usericon" src="static/images/happy_face.svg" alt="">
        </div>
        <div class="modal__body">
          <p>{{ getTranslations.home_modals_welcome_back_returning_back_you_start }}</p>
        </div>
        <!--div class="modal__footer">
          <a href="#" class="btn2 btn2--std btn2--small btn2--fixed">$#NEW GAME</a>
        </div-->
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  // modal_returning_unsubscribed.html
  name: 'welcome-returning-unsub',
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeReturningUnsub.vue